
export function downloadCalendarInvite(dateStr: string, spaceLabel: string) {
  const date = new Date(dateStr);
  const start = new Date(date.setHours(8, 0, 0, 0));
  const end = new Date(date.setHours(18, 0, 0, 0));

  const formatICSDate = (d: Date) => d.toISOString().replace(/-|:|\.\d+/g, '');

  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//SpaceShare//Parking Assignment//EN',
    'BEGIN:VEVENT',
    `UID:${Math.random().toString(36).substr(2)}@spaceshare.com`,
    `DTSTAMP:${formatICSDate(new Date())}`,
    `DTSTART:${formatICSDate(start)}`,
    `DTEND:${formatICSDate(end)}`,
    `SUMMARY:Parking Assigned: ${spaceLabel}`,
    `DESCRIPTION:Your car parking space ${spaceLabel} has been confirmed for today.`,
    'LOCATION:Main Office Site',
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\r\n');

  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `parking-${dateStr}-${spaceLabel}.ics`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function downloadBulkCalendarInvite(assignments: { date: string, spaceLabel: string }[]) {
  const formatICSDate = (d: Date) => d.toISOString().replace(/-|:|\.\d+/g, '').split('T')[0];

  const events = assignments.map(a => {
    const date = new Date(a.date);
    const dateStr = formatICSDate(date);
    const nextDay = new Date(date);
    nextDay.setDate(date.getDate() + 1);
    const nextDayStr = formatICSDate(nextDay);

    return [
      'BEGIN:VEVENT',
      `UID:${Math.random().toString(36).substr(2)}@spaceshare.com`,
      `DTSTAMP:${formatICSDate(new Date())}T000000Z`,
      `DTSTART;VALUE=DATE:${dateStr}`,
      `DTEND;VALUE=DATE:${nextDayStr}`,
      `SUMMARY:Parking: ${a.spaceLabel}`,
      `DESCRIPTION:Your car parking space ${a.spaceLabel} is confirmed at Main Office Site.`,
      'LOCATION:Main Office Site',
      'TRANSP:TRANSPARENT',
      'X-MICROSOFT-CDO-BUSYSTATUS:FREE',
      'END:VEVENT'
    ].join('\r\n');
  }).join('\r\n');

  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//SpaceShare//Parking Sync//EN',
    events,
    'END:VCALENDAR'
  ].join('\r\n');

  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `parking-sync.ics`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
